/**
 * After a deploy, a tab opened before it still asks for the old build's page files, which
 * no longer exist (Cloudflare Pages answers index.html, and the import fails). Reloading
 * fetches the new build. Reload at most once a minute, so a real failure still shows.
 */
const KEY = 'gc:stale-build-reload';

export function isStaleBuildError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return /dynamically imported module|Importing a module script failed|error loading dynamically imported module|Expected a JavaScript.*MIME type|Unable to preload CSS/i.test(
    message,
  );
}

/** Reload the page unless this tab already did in the last minute; true when it reloads. */
export function reloadForNewBuild(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // No session storage: reload anyway; the browser's own cache makes a loop unlikely.
  }
  window.location.reload();
  return true;
}
